
import CodeSnippet from '@/components/molecules/code-snippet/code-snippet';

export default {
  name: 'CodeExample',

  components: {
    CodeSnippet,
  },
};
